import type { FaireProductEntity } from "../../entity_types/product";

export const p_6q43eaxjth: FaireProductEntity = {
  token: "p_6q43eaxjth",
  type: "product",
  name: "Phenomenal Woman Necklace - Turquoise",
  brandToken: "b_2ki6r755",
  brandName: "JOY DRAVECKY JEWELRY",
  imageUrl:
    "https://cdn.faire.com/fastly/5f36aa6b8770c2038272834967ca6c4862d6f0bb57e9a3ce9d43d20cdee80499.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/53aa88f956895e924e63fe864d291e2ef753c605417ed0879d64f442f1d5355b.jpeg",
    "https://cdn.faire.com/fastly/bd6385d1329bb1ea098959617708a0a5eac76b7455f81411a4c79fee40c930bd.jpeg",
    "https://cdn.faire.com/fastly/1f9054bb2861cc5bd2e1ea3961b69089827663e3c59b2a440e031c36b674bc95.jpeg",
    "https://cdn.faire.com/fastly/7b9603123515ebabaec249cf6ca2e629d160b39d9503077ca1c8fd746226ba8f.jpeg",
  ],
  priceDollars: 55.6,
  description:
    "Experience a timeless celebration of strength, grace, and resilience with the Phenomenal Woman Necklace. Inspired by Maya Angelou’s iconic poem, this necklace is more than just a piece of jewelry—it’s a testament to your inner power and the beauty of self-discovery. \n\nCrafted for those navigating their physical, mental, and spiritual balance, this necklace carries a deeply personal connection. The back of the pendant bears an inscription of Proverbs 31, a tender reminder that perfection is not the goal—effort and authenticity are what truly define us. \n",
  tags: [],
  msrpDollars: 139,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:37.639Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
